export default [
  //  suppliers  router
  {
    meta: {
      is_auth: true,
      is_admin: true,
      title: "suppliers",
      layout: "dashboard",
    },
    path: "/suppliers",
    name: "suppliers",
    component: () => import("@/layouts/index/SupplierIndex.vue"),
    children: [
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Fournisseurs",
          layout: "dashboard",
        },
        path: "index",
        name: "suppliers-index",
        component: () => import("@/views/suppliers/Listing.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Ajouter un fournisseur",
          layout: "dashboard",
        },
        path: "create",
        name: "suppliers-create",
        component: () => import("@/views/suppliers/Create.vue"),
      },

      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Modifer le fournisseur",
          layout: "dashboard",
        },
        path: ":reference/edit",
        name: "suppliers-edit",
        component: () => import("@/views/suppliers/Edit.vue"),
      },
    ],
  },
];
